import React from 'react'
import { Container, TableRow, TableBody, TableHeader, TableHeaderCell, Table, TableCell} from 'semantic-ui-react';


export function InydeView(props) {
  const { DZ } = props;

  return (
    <div className='cotizacion-principal'>
 <Container className='cotizacion-principal_info'>
                <Container className='cotizacion-principal_info'>
                    <p>Asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesornom}</span></p>
                    <p>Correo asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesor}</span></p>
                    <br></br>
                    {DZ.nombreoficial && <p>Nombre oficial del producto: <span className='cotizacion-principal_info-nombre'>{DZ.nombreoficial}</span></p>}
                    <p>Nombre del producto:<span className='cotizacion-principal_info-dxp'>{DZ.nombre}</span></p>
                    <p>Familia del producto:<span className='cotizacion-principal_info-dxp'>{DZ.familia}</span></p>
                    <p>Activos: <span className='cotizacion-principal_info-dxp'>{DZ.activos}</span></p>
                    <p>Base: <span className='cotizacion-principal_info-base'>{DZ.base}</span></p>
                    <p>Presentación: <span className='cotizacion-principal_info-activos'>{DZ.presentacion}</span></p>
                    <p>Envase: <span className='cotizacion-principal_info-activos'>{DZ.envase}</span></p>
                    <p>Área: <span className='cotizacion-principal_info-dxp'>{DZ.area}</span></p>
                    <br></br>
                    <p>Genero del paciente: <span className='cotizacion-principal_info-base'>{DZ.genero}</span></p>
                    <p>Rango de edad: <span className='cotizacion-principal_info-dxp'>{DZ.rangoedad}</span></p>
                    <p>Tipo de piel: <span className='cotizacion-principal_info-dxp'>{DZ.tipopiel}</span></p>
                    <p>Padecimiento: <span className='cotizacion-principal_info-dxp'>{DZ.padecimiento}</span></p>
                    <br></br>
                    <p>Precio Objetivo: <span className='cotizacion-principal_info-activos'>{DZ.objetivo}</span></p>
                    {(DZ.sOpe && DZ.presupuesto) && <p>Presupuesto por KG InyDe: <span className='cotizacion-principal_info-nombre'>{DZ.presupuesto}</span></p>}
                    {DZ.costologrado && <p>Costo logrado por KG de InyDe: <span className='cotizacion-principal_info-nombre'>{DZ.costologrado}</span></p>}
                    {DZ.caducidad && <p>Caducidad: <span className='cotizacion-principal_info-nombre'>{DZ.caducidad}</span></p>}
                    {DZ.cancelmotivo && <p>Motivo de cancelación: <span className='cotizacion-principal_info-nombre'>{DZ.cancelmotivo}</span></p>}
                    {(!DZ.sIyD && DZ.backmotivo) && <p>Motivo de regreso: <span className='cotizacion-principal_info-nombre'>{DZ.backmotivo}</span></p>}
                </Container>
        </Container>
    </div>

  )
}
